import styled from 'styled-components';

import { colors } from 'theme';

export const SectionContainer = styled.div`
  padding: 20px;
  width: 100%;
`;

export const AlarmResponseProfileContainer = styled.div<{ $first?: boolean }>`
  position: relative;
  display: flex;
  flex-direction: row;
  padding: 8px 0;
  align-items: center;
`;

export const AlarmResponseProfileDetails = styled.div`
  color: ${({ theme }) => theme.palette.primary.dark};
  width: 100%;

  a {
    color: ${({ theme }) => theme.palette.primary.main};
    text-decoration: none;
  }

  display: flex;
  padding: 20px;
  align-items: flex-start;
  gap: 10px;
  flex: 1 0 0;
  border-radius: 8px;
  background: ${({ theme }) => theme.palette.grey[50]};
`;

export const AlarmResponseProfileTitle = styled.div`
  margin: 0;
  font-size: 1.4rem;
  line-height: 1.8rem;
`;

export const AlarmResponseProfileValue = styled.p`
  margin: 0;
  overflow-wrap: break-word;
  color: ${({ theme }) => theme.palette.text.primary};
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 143%;
  letter-spacing: 0.17px;
`;

export const AlarmResponseProfileField = styled.div`
  margin: 0;
  font-size: 1.3rem;
  line-height: 1.8rem;
  color: ${({ theme }) => theme.palette.primary.dark};
  :not(:first-child) {
    margin-top: 6px;
  }
`;

export const AlarmResponseProfileOrder = styled.div`
  height: 40px;
  width: 40px;
  border-radius: 50%;
  border: 1px solid ${({ theme }) => theme.palette.grey[200]};
  display: flex;
  padding: 20px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
  color: ${({ theme }) => theme.palette.primary.main};
  font-size: 15px;
  font-style: normal;
  font-weight: 700;
  line-height: 166%; /* 24.9px */
  letter-spacing: 0.4px;
  margin-right: 10px;
`;

export const AlarmResponseProfileHeader = styled.p`
  font-weight: 600;
  margin: 0;
  height: 16px;
  align-self: stretch;
  color: ${({ theme }) => theme.palette.text.secondary};
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 166%;
  letter-spacing: 0.4px;
`;

export const Empty = styled.p`
  font: 14px/20px Roboto;
  letter-spacing: 0px;
  color: ${colors.ui.chip.grayText};
  margin: 0;
`;
